const parseEnv = () => {
  const apiBaseUrl = import.meta.env.VITE_API_BASE_URL || 'https://qudusapp.com/api';
  
  // Validate URL format
  try {
    new URL(apiBaseUrl);
  } catch (error) {
    console.warn('Invalid API URL format:', error);
    return {
      apiBaseUrl: 'https://qudusapp.com/api'
    };
  }

  return {
    apiBaseUrl
  };
};

export const config = {
  apiBaseUrl: parseEnv().apiBaseUrl,
};